import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyCqaKYQoIMnHDJ5kqpKRrkT-6XmT3kSyT0",
  authDomain: "flor-paz.firebaseapp.com",
  projectId: "flor-paz",
  storageBucket: "flor-paz.appspot.com",
  messagingSenderId: "566644713675",
  appId: "1:566644713675:web:328455c98ec2ec0f70134e",
  measurementId: "G-CLV8PG1166",
};
// Initialize Firebase

const fire = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const storage = firebase.storage();
firebase.analytics();

export { fire, db, storage };
